import { Skeleton } from '@/components/ui/skeleton/skeleton.component';

export const TableViewSkeleton = () => {
  return (
    <div className="flex flex-col gap-y-2">
      <div className="rounded shadow border border-light-gray inline-flex flex-row justify-between items-center p-2 min-h-10 h-10">
        <Skeleton className="h-[20px] min-h-[20px] w-[180px] min-w-[180px] max-w-[180px]" />
        <Skeleton className="h-[20px] min-h-[20px] w-[48px] min-w-[48px] max-w-[48px]" />
        <Skeleton className="h-[20px] min-h-[20px] w-[100px] min-w-[100px] max-w-[100px]" />
        <Skeleton className="h-[20px] min-h-[20px] w-[120px] min-w-[120px] max-w-[120px]" />
        <Skeleton className="h-[0px] min-h-[0px] w-[20px] min-w-[20px] max-w-[20px]" />
      </div>
      {Array.from(Array(12).keys()).map((i) => (
        <div
          key={i}
          className="rounded shadow border border-light-gray inline-flex flex-row justify-between items-center p-2 min-h-10 h-10"
        >
          <Skeleton className="h-[20px] min-h-[20px] w-[180px] min-w-[180px] max-w-[180px]" />
          <Skeleton className="h-[20px] min-h-[20px] w-[48px] min-w-[48px] max-w-[48px]" />
          <Skeleton className="h-[20px] min-h-[20px] w-[100px] min-w-[100px] max-w-[100px]" />
          <Skeleton className="h-[20px] min-h-[20px] w-[120px] min-w-[120px] max-w-[120px]" />
          <Skeleton className="h-[20px] min-h-[20px] w-[20px] min-w-[20px] max-w-[20px]" />
        </div>
      ))}
    </div>
  );
};
